// TSS vite/03 §"Query keys".

export const pregnancyKeys = {
    all:    ['pregnancies'],
    list:   (filters) => ['pregnancies', 'list', filters],
    detail: (id) => ['pregnancies', 'detail', id],
};
